import { useEffect, useState } from "react";
import { Collapse } from "bootstrap";
import { ArrowDownIcon, ArrowRightIcon } from "./icons";

function CollapseForm(props) {
  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    const collapse = document.getElementById("collapseForm");
    const bsCollapse = new Collapse(collapse, { toggle: false });
    toggle ? bsCollapse.show() : bsCollapse.hide();
  });

  const onClick = () => setToggle(toggle => !toggle);
  const title = props.title || "Suchparameter";
  return (
    <div className="p-0 mb-one" {...props}>
      <button className="sectionTitle btn btn-default align-middle mb-0 text-start w-100" onClick={onClick}>
        {toggle
          ? <ArrowDownIcon></ArrowDownIcon>
          : <ArrowRightIcon></ArrowRightIcon>
        }
        <span>{title}</span>
      </button>
      <div className="collapse mt-one" id="collapseForm">
        {props.children}
      </div>
    </div>
  );
}
export default CollapseForm;
